import KonvaService from '@/services/konva';
import { mainRenderer } from './use-canvas-render';
import { useEditorStore } from '@/store/use-editor-store';
import { getImageAndVideoDoms } from './use-canvas-utils';

export const useCanvasPlay = () => {
  const editorStore = useEditorStore();
  /**
   * 播放动画
   * @param ifttt 需要预览的ifttt动画
   * @returns
   */
  const playIftttAni = (iftttId: string, aniId: string) => {
    const _renderer = mainRenderer;

    if (!_renderer) return;
    _renderer.cleanCanvas();
    _renderer.runtime.resetIftttAnimations2(iftttId, aniId);
    // 禁用画布konva
    KonvaService.getIns()?.clear();
    editorStore.iftttPlaying = true;
    _renderer.tick();
  };

  const playFrameAni = (frameId: string) => {
    const _renderer = mainRenderer;
    if (!_renderer) return;
    getImageAndVideoDoms({
      watchfaceAst: _renderer.options.ast,
      wholeFrameIds: [frameId],
      colorId: editorStore.themeColor?.id ?? '',
      themeId: editorStore.themeId
    }).then((res) => {
      _renderer.runtime.updateImages({
        images: res.images,
        videos: res.videos
      });
      _renderer.runtime.resetFrameAnimation([frameId]);
      _renderer.tick();
    });
  };

  return { playIftttAni, playFrameAni };
};
